<template>
  <div class="app header-fixed">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#">
        <img class="d-sm-down-none mr-auto img-fluid"
             :src="$auth.user().rto.logo"
             width="89px"
             alt="RTO Logo"
             v-if="$auth.user().rto && $auth.user().rto.logo"
        >
        <template v-else>DigidoLMS</template>
      </b-link>
      <SidebarMinimizerHeader class="d-md-down-none" display="lg"/>
      <b-navbar-nav class="ml-auto">
        <b-nav-item :href="$auth.user().role.user_guide" target="_blank" v-if="$auth.user().role.user_guide">
          <i class="icon-map"></i>
        </b-nav-item>
        <b-nav-item class="d-sm-down-none mr-2" to="notifications">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger" v-if="$store.state.notificationsCount">{{ $store.state.notificationsCount }}</b-badge>
        </b-nav-item>
        <DefaultHeaderDropdownAccnt class="mr-5"/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarMinimizer class="d-lg-none"/>
      </AppSidebar>

      <main class="main">
        <!--<Breadcrumb :list="list" class="m-0 border-0 rounded-0"/>-->
        <div class="container-fluid p-0">
          <transition name="fade" mode="out-in">
            <router-view :key="$route.path"></router-view>
          </transition>
        </div>
      </main>
    </div>
    <Footer>
      <!--footer-->
      <div>
        <a href="https://flooringtechnology.com.au/">
          <img class="d-sm-down-none mr-auto img-fluid"
               :src="$auth.user().rto.logo"
               width="89px"
               alt="RTO Logo"
               v-if="$auth.user().rto && $auth.user().rto.logo"
          >
          <template v-else>DigidoLMS</template>
        </a>
      </div>
      <div class="ml-auto d-sm-down-none">
        <span class="mr-1">Developed with <span class="text-danger">&#9829;</span> by</span>
        <a href="https://elliscreative.com.au">EllisCreative</a>
      </div>
    </Footer>
  </div>

</template>

<script>
import { Sidebar as AppSidebar, SidebarMinimizer, SidebarNav, SidebarToggler } from '@coreui/vue/src/components/Sidebar';
import Footer from '@coreui/vue/src/components/Footer/Footer';
import { Header as AppHeader } from '@coreui/vue/src/components/Header';
import DefaultHeaderDropdownAccnt from './HeaderDropdownAccnt';
import navItems from '../nav';
import SidebarMinimizerHeader from '../components/SidebarMinimizer';
import Echo from '../mixins/Echo';
import LogRocket from 'logrocket';

export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    AppSidebar,
    Footer,
    DefaultHeaderDropdownAccnt,
    SidebarToggler,
    SidebarNav,
    SidebarMinimizerHeader,
    SidebarMinimizer
  },
  mixins: [Echo],
  data () {
    return {
      sidebarOpen: true
    };
  },
  computed: {
    name () {
      return this.$route.name;
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
    nav () {
      return navItems.filter(item => {
        if (Array.isArray(item.access) || typeof item.access === 'string') {
          return this.$auth.check(item.access);
        } else {
          return true;
        }
      }).map(item => {
        if (item.name === 'Messages' && this.$store.state.messagesCount) {
          item.badge = {
            variant: 'danger',
            text: this.$store.state.messagesCount
          };
        }
        if (item.name === 'Signoff Forms') {
          if (this.$store.state.mySignoffForms.data.length) {
            item.badge = {
              variant: 'danger',
              text: this.$store.state.mySignoffForms.data.length
            };
          }
        }
        if (item.name === 'Notifications' && this.$store.state.notificationsCount) {
          item.badge = {
            variant: 'danger',
            text: this.$store.state.notificationsCount
          };
        }

        if (item.children) {
          item.children = item.children.filter(child => {
            if (Array.isArray(child.access) || typeof child.access === 'string') {
              return this.$auth.check(child.access);
            } else {
              return true;
            }
          });
        }

        return item;
      });
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      LogRocket.identify(this.$auth.user().id, this.$auth.user());
      this.$bugsnagClient.user = this.$auth.user();
    }
    this.$store.dispatch('LOAD_USER_COURSES', this);
    this.$store.dispatch('LOAD_MY_SIGNOFF_FORMS', this);
    this.getMessageCount();
    this.getNotificationsCount();
  },
  methods: {
    getMessageCount () {
      this.axios.get('messages/unread').then(rsp => {
        this.$store.commit('setMessagesCount', rsp.data.count);
      });
    },
    getNotificationsCount () {
      this.axios.get('/notifications/unread').then(rsp => {
        this.$store.commit('setNotificationsCount', rsp.data);
      });
    }
  }
};
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>